export default "__VITE_ASSET__e21a3b73__"